module.exports = __webpack_public_path__ + "static/media/partner.7f4474e4.png";